export default __webpack_public_path__ + "static/media/SEC1550.34I-38847_-22819_0.cfc350b1.jpg";